// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--1Y_dd","image":"styles-module--image--jf287"};